const cookieName = 'cookieconsent';
const cookieValue = 'agreed';

class PolicyNote {
    constructor() {
        const dCookie = this.getCookie(cookieName);
        this.consentMessage = document.querySelector('.js-cookie');

        if (!this.consentMessage) {
            return
        }

        if (dCookie === undefined || dCookie != cookieValue) {
            this.agreeButton = document.querySelector('.js-cookie__agree');
            this.removeButton = document.querySelector('.js-cookie__remove');
            this.consentMessage.style.display = '';
            this.setListeners();
        } else {
            this.consentMessage.remove();
        }
    }

    setListeners() {
        if (this.agreeButton) {
            this.agreeButton.addEventListener('click', (event) => {
                this.setCookie(cookieName, cookieValue, {path: '/', expires: 365});
                this.consentMessage.remove();
            });
        }
        if (this.removeButton) {
            this.removeButton.addEventListener('click', (event) => {
                this.consentMessage.remove();
            });
        }
    }

    getCookie(name) {
        let matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    setCookie(name, value, options = {}) {

        if (options.expires.toUTCString) {
            options.expires = options.expires.toUTCString();
        }

        let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

        for (let optionKey in options) {
            updatedCookie += "; " + optionKey;
            let optionValue = options[optionKey];
            if (optionValue !== true) {
                updatedCookie += "=" + optionValue;
            }
        }

        document.cookie = updatedCookie;
    }
}

new PolicyNote();